module.exports = __webpack_public_path__ + "static/content-major-works-533cfffb89a76fb33c9bffc9200d95fc.png";